// extracted by mini-css-extract-plugin
export var smallSpinner = "_se-0";